module.exports = __webpack_public_path__ + "static/img/8.47b5f9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/8.png
// module id = TaVU
// module chunks = 0